import { StateStatRecord } from 'types/OrbitTypes'
import PromisedResource from './PromisedResource'
import JSONAPISource from '@orbit/jsonapi'
import { NullableMomentRange } from 'components/DatePickerPopover/types'

function getPromise({ remote, dateRange, clientId }: StateStatsResourceProps) {
  const options = {
    sources: {
      remote: {
        settings: {
          params: {
            ...(dateRange && { start_time: dateRange[0].format(), end_time: dateRange[1].format() }),
          }
        }
      }
    }
  }

  return remote.query<StateStatRecord[]>(q => q.findRelatedRecords({ type: 'client', id: clientId }, 'stateStats'), options)
}

export type StateStatsResourceProps = {
  remote: JSONAPISource
  dateRange: NullableMomentRange
  clientId: string
}

export default class StateStatsResource extends PromisedResource<StateStatRecord[]> {
  constructor({ remote, dateRange, clientId }: StateStatsResourceProps) {
    super(getPromise({ remote, dateRange, clientId }))
  }
}
